import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { ProjectAreaQueries } from '../useProjectAreaQueries';

const ProjectReportsPage = lazyWithSuspense(() => import('./ProjectReportsPage'));

export default makePage<any, [], ProjectAreaQueries>({
  WrappedPage: ProjectReportsPage,
  inheritParent: true,
});
